<template>
  <section class="assessmentSection">
    <ProgressBar :value="15" />
    <div class="pageContent mb-12">
      <div class="pageTitle">
        Upgrade your system
        <br />with smart home features
      </div>

      <div class="text-bold">Smart home upgrades make everyday life easier</div>
      <div class="mb-4">
        These fully integrate with your security system and can be used to build
        automation that save you time and money.
      </div>

      <div class="text-bold">Control all of these devices with your phone</div>
      <div class="mb-4">
        All of these devices work through the ADT smart phone app that controls
        your security system as well. Everything is in one place.
      </div>
    </div>

    <div class="equipment-section">
      <div class="pageContent">
        <div class="pageTitle">
          Yes, add smart devices to my system
        </div>
        <div class="py-3 px-5 bg-blue text-white rounded mb-12 -mt-4">
          <b class="text-heavy mr-4">1 FREE device</b> <br class="mobile-only" /> <span class="text-sm">
            discount applied at checkout
          </span>
        </div>

        <EquipmentInfoWithQuantity :equipment="equipment" />
      </div>
    </div>

    <div class="continue-section">
      <continue-button to="/system" />
      <ModuleNeedHelp />
    </div>
  </section>
</template>

<script>
import ProgressBar from "../components/ProgressBar.vue";
import EquipmentInfoWithQuantity from "../components/EquipmentInfoWithQuantity.vue";
import ModuleNeedHelp from "../components/ModuleNeedHelp.vue";
import EquipmentService from "../Services/Equipment";

let Equipment = new EquipmentService();

export default {
  components: {
    ProgressBar,
    EquipmentInfoWithQuantity,
    ModuleNeedHelp,
  },
  data: () => ({
    descriptionVisibilities: [false, false],
    equipment: [],
  }),
  async mounted() {
    let equipment = await Equipment.getByCategory("automation");
    this.equipment = equipment;
  },
};
</script>

<style src="./AssessmentModule.css" scoped></style>
<style src="../../sass/components/continue-section.css" scoped></style>
